import {ExperienceLevel, Profile, ProfileSkill} from "@betrue/shared/interfaces";
import {ProfileSkillsView} from "./profile-skills.view";
import PropTypes, {InferProps} from "prop-types";
import {currentProfile, usePersonView, useProfile} from "@betrue/front/services";
import {useEffect, useState} from "react";
import {CircularProgress} from "@material-ui/core";

export const profileSkillsPropTypes = {
  skillsLinkedToYourJobTitle: PropTypes.string,
  skillsHeader: PropTypes.string,
  skillsHeaderHelper: PropTypes.string,
  experiencesHeader: PropTypes.string,
  experiencesHeaderHelper: PropTypes.string,
  canDelete: PropTypes.bool,
  canUpdate: PropTypes.bool
};

export type ProfileSkillsProps = InferProps<typeof profileSkillsPropTypes>

export const ProfileSkills = (props: ProfileSkillsProps) => {


  const [profile,{getProfileById,removeSkillFromProfile,updateProfileSkill}] = useProfile<Profile>(currentProfile)
  const [cleanedSkills, setCleanedSkills] = useState([])

  const [,viewProfile] = usePersonView()
  useEffect(() => {
    if (viewProfile) {
      setCleanedSkills(Array.from((new Map(viewProfile.skills.map(item =>
        [item.skill.label, item])).values())))
    }

  }, [viewProfile])


  const handleDeleteProfileSkill = (ps: ProfileSkill) => {
    removeSkillFromProfile({...ps.skill}, viewProfile.id)
  }

  const handleChangeExperience = (ps: ProfileSkill, xp: ExperienceLevel) => {
    updateProfileSkill({...ps.skill}, viewProfile.id, xp)
  }


  if (!viewProfile) return (<><CircularProgress/></>)

  return (<ProfileSkillsView
    deleteProfileSkill={handleDeleteProfileSkill}
    profilesSkills={cleanedSkills}
    canDelete={props.canDelete}
    canUpdate={props.canUpdate}
    skillsHeader={props.skillsHeader}
    skillsHeaderHelper={props.skillsHeaderHelper}
    experiencesHeader={props.experiencesHeader}
    experiencesHeaderHelper={props.experiencesHeaderHelper}
    changeExperience={handleChangeExperience}
  />)
}

ProfileSkills.propTypes = profileSkillsPropTypes

